import config from '@/common/config';
import { transfer } from '@/features/account-abstraction/constants/abis';
import { AccountAbstractionState } from '@/features/account-abstraction/store/AccountAbstractionContext';
import { PaymasterMode } from '@biconomy/account';
import { encodeFunctionData, parseUnits } from 'viem/utils';

const withSponsorship = {
  paymasterServiceData: {
    mode: PaymasterMode.SPONSORED,
    preferredToken: config.contracts.usdt,
  },
};
export async function transferTokens(
  accountAbstractionState: AccountAbstractionState,
  recipientAddress: `0x${string}`,
  amount: number,
  decimals: number,
  tokenAddress: `0x${string}`,
) {
  if (accountAbstractionState.smartAccount && recipientAddress && amount) {
    const withdrawTx = {
      to: tokenAddress,
      data: encodeFunctionData({
        abi: transfer,
        functionName: 'transfer',
        args: [recipientAddress, parseUnits(amount.toString(), decimals)],
      }),
    };

    const { wait } = await accountAbstractionState.smartAccount.sendTransaction(withdrawTx, {
      ...withSponsorship,
    });

    const tx = await wait();
    if (tx.success === 'false') {
      throw new Error(tx.reason);
    }
    console.timeEnd('withdrawUsdt'); // End timing and log the duration
    return tx;
  }
  console.timeEnd('withdrawUsdt'); // End timing and log the duration
  throw new Error('Invalid parameters');
}
